import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

export const admin: Routes = [
  {
    path: '',
    children: [
      {
        path: 'dash',
        loadComponent: () => import('./cpanel.component').then((m) => m.CpanelComponent),
      },
    ],
  },
];
@NgModule({
  imports: [RouterModule.forChild(admin)],
  exports: [RouterModule],
})
export class cpanelRoutingModule {
  static routes = admin;
}
